// No Supabase import: @/lib/supabase throws at load without the VITE_ env vars, as in CI.

export type ExportSystem = "samsara" | "trackpod"
export type ExportTrigger = "manual" | "ui" | "cron" | "unknown"

export interface RouteExport {
  id: string
  route_instance_id: string
  system: ExportSystem
  trigger_source: ExportTrigger
  status: "success" | "error"
  external_route_id: string | null
  error: string | null
  attempted_by: string | null
  attempted_at: string
}

/** Latest attempt per system for one route. Either side may be absent. */
export type LatestExports = Partial<Record<ExportSystem, RouteExport>>

export interface ReexportTarget {
  routeInstanceId: string
  system: ExportSystem
}

export interface ReexportDetail {
  routeInstanceId: string
  routeCode: string
  system: ExportSystem
  status: "success" | "error"
  message: string
}

export interface ReexportResponse {
  success: boolean
  message: string
  exported: number
  failed: number
  details: ReexportDetail[]
}

export function externalIdFor(
  route: { samsara_route_id?: string; trackpod_route_id?: string },
  system: ExportSystem
): string | undefined {
  return system === "samsara" ? route.samsara_route_id : route.trackpod_route_id
}

/** Newest attempt per route per system, by timestamp rather than trusting query order. */
export function latestExportsByRoute(rows: RouteExport[]): Record<string, LatestExports> {
  const latest: Record<string, LatestExports> = {}

  for (const row of rows) {
    const forRoute = (latest[row.route_instance_id] ??= {})
    const current = forRoute[row.system]
    // Parsed, not string-compared, in case offsets are mixed.
    if (!current || Date.parse(row.attempted_at) > Date.parse(current.attempted_at)) {
      forRoute[row.system] = row
    }
  }

  return latest
}
